const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockShifts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "35px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "m 50,965.36219 c -20.43443,0 -37,16.56556 -37,37.00001 0,20.4344 16.56557,37 37,37 20.43444,0 37,-16.5656 37,-37 0,-20.43444 -16.56556,-37 -37,-37 z m 0,9 c 1.1046,0 2,0.8954 2,2 l 0,25.18751 16.375,16.375 c 0.78107,0.7811 0.78107,2.0314 0,2.8125 -0.78107,0.7811 -2.03142,0.781 -2.8125,0 -5.64367,-5.6543 -11.31444,-11.3717 -16.96875,-16.9688 C 48.23182,1003.4065 48,1002.9145 48,1002.3622 l 0,-26.00001 c 0,-1.1046 0.8954,-2 2,-2 z",
    fill: "#000000",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockShifts);
export default __webpack_public_path__ + "static/media/clock-shifts.1fbf032df36c194828cd7e898914bdb8.svg";
export { ForwardRef as ReactComponent };